import React from 'react';
import './FloatingParticles.css';

const FloatingParticles: React.FC = () => {
  // 20 parçacık oluştur
  const particles = Array.from({ length: 20 }, (_, i) => i);

  return (
    <div className="floating-particles">
      {particles.map((i) => (
        <div 
          key={i} 
          className="particle"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 15}s`,
            animationDuration: `${15 + Math.random() * 20}s`,
            width: `${3 + Math.random() * 5}px`,
            height: `${3 + Math.random() * 5}px`,
            opacity: 0.3 + Math.random() * 0.4,
          }}
        />
      ))}
    </div>
  );
};

export default FloatingParticles;
